/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gateway_Sub_Page_SubtitleInputs */



/**
* | output |
* | --- |
* | "API-first plan. €129/month plus pay-per-use." |
*
* @param {Gateway_Sub_Page_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gateway_sub_page_subtitle = /** @type {((inputs?: Gateway_Sub_Page_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gateway_Sub_Page_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("API-First-Plan. 129 €/Monat plus nutzungsabhängig.")
	return /** @type {LocalizedString} */ ("API-first plan. €129/month plus pay-per-use.")
});